var _g, _g2, _line, _g3, _g4, _g5, _path, _path2, _path3, _path4, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _circle, _circle2, _circle3, _circle4, _path5, _circle5, _g16, _g17, _g18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 683.817,
    height: 439.667,
    viewBox: "0 0 683.817 439.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Sec",
    transform: "translate(-1020.458 -5112.678)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(1026.083 5142.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M115.082,411.922c-17.7-4.327-35.434-13.94-47.235-27.959-36.864-43.8,6.335-99.93,49.316-117.6,20.96-8.621,39.851-18.919,46.011-42.818,5.893-22.864-10.245-46.759-14.41-68.574-8.386-43.921,31.111-77.895,72.779-77.9,38.408,0,55.7,14.636,93.806,40.168,28.808,19.3,82.9,30.616,124.459,26.537,49.493-4.858,68.154-26.538,107.6-44.185,27.149-12.145,64.994-14.743,90.391,3.259,27.129,19.229,16.819,56.884,19.908,85a52.193,52.193,0,0,0,6.143,20.2c22.226,39.221,67.754,41.238,67.754,99.318,0,43.657-72.575,59.851-107.329,64.588",
    transform: "translate(-53.913 -65.849)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    strokeDasharray: "5 3.5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 14.815,
    transform: "translate(50.783 127.166)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 14.815,
    transform: "translate(65.599 135.406)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 14.815,
    transform: "translate(502.902 62.444)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 14.815,
    transform: "translate(493.498 70.685)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 20.133,
    transform: "translate(516.076 66.754)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 10.66,
    transform: "translate(645.283 238.065)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 14.815,
    transform: "translate(635.617 229.918)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 14.815,
    transform: "translate(155.421 22.447)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    x2: 24.361,
    transform: "translate(131.287 200.986)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 12.645,
    transform: "translate(160.796 200.986)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M483.061,230.024a4.782,4.782,0,1,1-4.782-4.781A4.782,4.782,0,0,1,483.061,230.024Z",
    transform: "translate(-37.655 -60.107)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M663.987,198.169a4.782,4.782,0,1,1-4.782-4.782A4.782,4.782,0,0,1,663.987,198.169Z",
    transform: "translate(-30.645 -61.341)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M493.084,98.924a4.781,4.781,0,1,1-4.781-4.782A4.782,4.782,0,0,1,493.084,98.924Z",
    transform: "translate(-37.267 -65.187)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M582.852,105.728a2.379,2.379,0,1,1-2.379-2.379A2.379,2.379,0,0,1,582.852,105.728Z",
    transform: "translate(-33.602 -64.83)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M442.832,277.8a2.379,2.379,0,1,1-2.379-2.379A2.378,2.378,0,0,1,442.832,277.8Z",
    transform: "translate(-39.028 -58.163)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M176.72,113.534a2.379,2.379,0,1,1-2.38-2.38A2.38,2.38,0,0,1,176.72,113.534Z",
    transform: "translate(-49.339 -64.528)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M73.211,256.641a2.379,2.379,0,1,1-2.379-2.379A2.379,2.379,0,0,1,73.211,256.641Z",
    transform: "translate(-53.35 -58.983)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M186.019,209.725a2.379,2.379,0,1,1-2.379-2.379A2.379,2.379,0,0,1,186.019,209.725Z",
    transform: "translate(-48.979 -60.801)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(60.82 75.107)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    y2: 5.63,
    transform: "translate(2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_12",
    "data-name": "Line 12",
    x1: 5.63,
    transform: "translate(0 2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(390.184)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    y2: 5.63,
    transform: "translate(2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_14",
    "data-name": "Line 14",
    x1: 5.63,
    transform: "translate(0 2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(567.379 87.069)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_15",
    "data-name": "Line 15",
    y2: 5.63,
    transform: "translate(2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_16",
    "data-name": "Line 16",
    x1: 5.63,
    transform: "translate(0 2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(659.428 162.321)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y2: 5.63,
    transform: "translate(2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x1: 5.63,
    transform: "translate(0 2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(632.802 261.146)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y2: 5.63,
    transform: "translate(2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x1: 5.63,
    transform: "translate(0 2.815)",
    fill: "none",
    stroke: "#a9c6ea",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(385.895 127.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M513.984,260.247a47.336,47.336,0,0,0,6.158-21.187l-10.006-1.386a37.122,37.122,0,0,0-1.1-9.9l9.474-3.539A47.668,47.668,0,0,0,507.88,204.9l-8.065,6.1a37.112,37.112,0,0,0-7.768-6.235l4.192-9.19a47.323,47.323,0,0,0-21.188-6.157l-1.386,10.005a37.12,37.12,0,0,0-9.9,1.1l-3.538-9.474a47.661,47.661,0,0,0-19.336,10.628l6.1,8.065a37.15,37.15,0,0,0-6.236,7.769l-9.19-4.192a47.315,47.315,0,0,0-6.157,21.187l10.005,1.386a37.132,37.132,0,0,0,1.1,9.9l-9.474,3.538a47.651,47.651,0,0,0,10.629,19.336l8.064-6.1a37.109,37.109,0,0,0,7.769,6.235l-4.192,9.19a47.314,47.314,0,0,0,21.187,6.157l1.386-10.005a37.131,37.131,0,0,0,9.9-1.1l3.538,9.473a47.649,47.649,0,0,0,19.336-10.628l-6.1-8.065a37.131,37.131,0,0,0,6.235-7.768Zm-47.884-.482a23.931,23.931,0,1,1,29.657-16.3A23.931,23.931,0,0,1,466.1,259.765Zm1.753-6.034a17.647,17.647,0,1,1,21.87-12.021A17.647,17.647,0,0,1,467.853,253.731Z",
    transform: "translate(-425.413 -189.421)",
    fill: "#e4ecf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(437.941 79.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M522.17,164.536a23.385,23.385,0,0,0-3.439-10.338l-4.455,2.243a18.377,18.377,0,0,0-3.223-3.715l2.858-4.095a23.534,23.534,0,0,0-9.742-4.877L502.6,148.5a18.363,18.363,0,0,0-4.906-.354l-.873-4.911a23.384,23.384,0,0,0-10.338,3.439l2.243,4.455a18.325,18.325,0,0,0-3.715,3.223l-4.095-2.858a23.538,23.538,0,0,0-4.878,9.741l4.742,1.566a18.313,18.313,0,0,0-.355,4.906l-4.91.873a23.35,23.35,0,0,0,3.439,10.338l4.455-2.243a18.322,18.322,0,0,0,3.223,3.715l-2.859,4.095a23.527,23.527,0,0,0,9.742,4.877l1.566-4.741a18.311,18.311,0,0,0,4.905.355l.874,4.91a23.35,23.35,0,0,0,10.338-3.439l-2.244-4.455a18.356,18.356,0,0,0,3.716-3.223l4.095,2.858a23.529,23.529,0,0,0,4.877-9.741l-4.741-1.566a18.392,18.392,0,0,0,.355-4.9Zm-20.187,11.455a9.943,9.943,0,1,1,6.3-12.574A9.943,9.943,0,0,1,501.983,175.991Z",
    transform: "translate(-475.518 -143.23)",
    fill: "#e4ecf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(167.851 34.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M286.9,132.554a35.746,35.746,0,0,0-5.263-15.821l-6.818,3.433a28.055,28.055,0,0,0-4.934-5.685l4.374-6.268a36.007,36.007,0,0,0-14.91-7.464l-2.4,7.257a28.023,28.023,0,0,0-7.508-.543l-1.337-7.516a35.765,35.765,0,0,0-15.821,5.264l3.433,6.818a28.023,28.023,0,0,0-5.685,4.934l-6.267-4.375A36.013,36.013,0,0,0,216.3,127.5l7.257,2.4a28.065,28.065,0,0,0-.543,7.508l-7.515,1.336a35.74,35.74,0,0,0,5.264,15.822l6.817-3.433a28.087,28.087,0,0,0,4.934,5.685l-4.374,6.267a36.009,36.009,0,0,0,14.91,7.465l2.4-7.257a28.029,28.029,0,0,0,7.508.543l1.337,7.515a35.746,35.746,0,0,0,15.821-5.263l-3.433-6.818a28.089,28.089,0,0,0,5.685-4.934l6.268,4.374A36.007,36.007,0,0,0,286.1,143.8l-7.257-2.4a28.027,28.027,0,0,0,.543-7.508Zm-30.9,17.533a15.219,15.219,0,1,1,9.635-19.245A15.22,15.22,0,0,1,256.008,150.087Z",
    transform: "translate(-215.503 -99.946)",
    fill: "#e4ecf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(120.773 84.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M220.355,187.5a26.8,26.8,0,0,0,3.488-12l-5.668-.785a21,21,0,0,0-.623-5.608l5.367-2a27,27,0,0,0-6.022-10.955l-4.567,3.458a21.016,21.016,0,0,0-4.4-3.532l2.375-5.206a26.8,26.8,0,0,0-12-3.488l-.785,5.668a21,21,0,0,0-5.608.623l-2-5.367a26.988,26.988,0,0,0-10.954,6.022l3.457,4.567a21.016,21.016,0,0,0-3.532,4.4l-5.206-2.375a26.8,26.8,0,0,0-3.488,12l5.668.785a21,21,0,0,0,.623,5.608l-5.367,2a26.989,26.989,0,0,0,6.022,10.954l4.568-3.456a21.039,21.039,0,0,0,4.4,3.531l-2.375,5.206a26.8,26.8,0,0,0,12,3.488l.785-5.668a21,21,0,0,0,5.608-.623l2,5.367a27,27,0,0,0,10.954-6.022l-3.457-4.568a21.05,21.05,0,0,0,3.532-4.4Zm-27.126-.273a13.556,13.556,0,1,1,16.8-9.234A13.556,13.556,0,0,1,193.229,187.226Zm.994-3.417A10,10,0,1,1,206.612,177,10,10,0,0,1,194.223,183.809Z",
    transform: "translate(-170.181 -147.378)",
    fill: "#e4ecf9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(1051.661 5357.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(184.987 75.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M344.312,461.961c3.163-6.527,19.655-35.094,37.042-44.531a18.781,18.781,0,0,1,7.045-2.547,7.562,7.562,0,0,1,6.75,2.565,8.49,8.49,0,0,1,1.135,6.589c-3.158,17.87-23.51,24.712-33.451,37.925",
    transform: "translate(-253.227 -342.475)",
    fill: "#d7e3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M344.891,463.249s16.361-32.3,32.335-51.535c7.562-9.108,12.756-25.979,4.805-31.034-11.505-7.313-22.81,8.978-27.99,17.067-7.833,12.233-13.6,25.77-18.04,39.563-.644,2-6.512,25.94-6.628,25.94h15.518Z",
    transform: "translate(-253.805 -343.87)",
    fill: "#d7e3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M375.772,389.514c-15.087,19.076-27.6,47.315-35.917,73.321",
    transform: "translate(-253.399 -343.457)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M313.4,463.359s-1.9-49.694-23.888-72.669c-5.941-6.207-15.681-12.658-23.673-14.425-10.358-2.29-10.077,9.891-8.2,17.784,2.431,10.229,10.788,16.605,16.816,24.224,11.093,14.019,17.713,23.271,25.811,45.086",
    transform: "translate(-256.624 -343.981)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M319.262,464.514c5.936-10.861,3.849-57.3.871-71.849a74.221,74.221,0,0,0-12.119-28.048c-5.261-7.316-20.985-23.441-30.238-16.889-5.353,3.79,2.754,17.442,4.894,21.542A233.4,233.4,0,0,1,299.4,411.383a255.927,255.927,0,0,1,10.074,52.456c.018.224.032.45.048.675",
    transform: "translate(-255.874 -345.135)",
    fill: "#d7e3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M318.72,464.553c-1.956-26-.7-65.911,11.019-88.454,13.293-25.563,30.621-37.365,33.136-27.4,7.3,28.895-21.978,106.609-30.221,115.856",
    transform: "translate(-254.247 -345.175)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M262.7,384.243c23.661,16.494,39.991,47.735,43.031,78.8",
    transform: "translate(-256.389 -343.661)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M286.007,355.655c11.626,10.381,17.536,26.619,21.109,42.343,4.922,21.655,7.289,43.848,8.066,66.15",
    transform: "translate(-255.486 -344.768)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M355.07,359.094c-14.311,32.878-26.38,68.4-28.4,104.92",
    transform: "translate(-253.91 -344.635)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M387.842,420.885s-20.915,13.892-35.512,40.734",
    transform: "translate(-252.916 -342.241)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(451.967 45.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M592.549,465.591c3.107-41.071-.354-81.353,15.291-120.272,4.441-11.046,14.559-28.471,28.553-29.066,21.613-.92,8.38,42.5,4.465,58.753a241.719,241.719,0,0,1-10.174,30.835c-6.916,17.717-17.317,42.489-25.176,59.751",
    transform: "translate(-510.588 -315.983)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M583.408,465.6c-6.8-17.411-13.463-34.879-20.194-52.32-5.97-15.467-12.917-30.592-17.741-46.482-3.672-12.094-13.16-39.812.731-48.332C570.941,303.3,590.71,362,593.319,382.853c3.439,27.48,2.7,55.123,3.109,82.748",
    transform: "translate(-512.667 -315.993)",
    fill: "#d7e3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M564.73,463.931s-14.455-18.466-20.975-27.126c-14.564-19.345-32.521-40.355-29.841-62.1.617-5,2.451-10.575,7.48-13.536a17.48,17.48,0,0,1,10.384-1.98c11.834,1.128,22.437,18.314,27.762,27.125,10.426,17.255,26.572,77.616,26.572,77.616",
    transform: "translate(-513.645 -314.323)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M552.178,330.093c17.645,35.685,34.868,101.766,35.29,134.961",
    transform: "translate(-512.152 -315.446)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M525.771,369.547c15.525,29.826,47.1,93.979,47.1,93.979",
    transform: "translate(-513.175 -313.918)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M635.274,325.345C622.6,353.6,605.242,414.839,598.25,465.321",
    transform: "translate(-510.367 -315.63)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M605.613,464.184s7.225-32.187,12.225-50.457c5.438-19.869,23.227-50.279,41.927-58.919,4.3-1.989,9.493-3.355,13.655-1.086a11.853,11.853,0,0,1,5.219,6.705c3.183,9.295-12.388,38.647-17.742,46.884-10.485,16.131-25.5,41.76-37.409,56.872",
    transform: "translate(-510.081 -314.577)",
    fill: "#d7e3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M669.787,360.953c-22.108,19.195-51.682,80.4-59.95,102.906",
    transform: "translate(-509.918 -314.251)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M146.289,445.65c-2.832-15.011-7.475-44.775-11-63.042-1.7-8.839-6.639-19.634-9.769-28.02C119.81,339.288,106,312.7,88.886,314.121c-21.241,1.764-4.075,39.949,1.334,54.365a209.049,209.049,0,0,0,12.949,27.022c8.488,15.4,21.071,36.838,30.438,51.7",
    transform: "translate(-78.537 -270.978)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M155.713,430.129c-5.183-13.557-3.783-30.8-3.765-45.149.031-25.823,9-62.128,25.815-79.075,6.932-6.985,18.4-14.753,25.852-4.074,7.056,10.112-1.1,37.6-3.672,49.408-5.034,23.128-29.14,65.963-36.1,88.355",
    transform: "translate(-75.7 -271.656)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M190.989,313c-11.948,30.992-28.01,87.54-32.108,120.5",
    transform: "translate(-75.424 -271.019)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M90.229,322.345c15.142,24.357,37.337,76.528,49.08,121.934",
    transform: "translate(-78.084 -270.657)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M145.248,414.437c6.372-10.426,13.928-44.269,15.651-56.366,2.424-17.008,2.685-34.978-1.525-51.733-2.842-11.3-15.844-45.121-32.161-29.87-7.662,7.162-6.439,46.193-5.526,56.641,1.788,20.461,12.386,57.1,16.023,77.314",
    transform: "translate(-76.892 -272.585)",
    fill: "#d7e3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M135.681,284.72c11.2,29.178,8.366,101.688,4.864,127.046",
    transform: "translate(-76.323 -272.115)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 652.153,
    transform: "translate(1020.458 5551.845)",
    fill: "none",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_262",
    "data-name": "Group 262",
    transform: "translate(1187.873 5243.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(47.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M301.888,177.961c3.187-3.145,10.924-13.773,11.8-13.511s-1.794,4.036-1.031,4.116,5.266-5.448,6.075-4.953c1.095.672-3.823,6.087-3.823,6.087s5.682-5.662,6.463-4.805c.554.608-3.584,5.129-4.949,7.055,1.744-1.9,4.935-4.642,5.5-4s-2.195,3.775-4.174,6.292c1.382-1.455,4.04-3.967,4.586-3.4s-6.111,10.7-12.207,18.1",
    transform: "translate(-253.207 -163.582)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M262.821,216.45a457.916,457.916,0,0,0,45.315-44.358l10.185,6.8s-17.094,26.5-39.467,49.307",
    transform: "translate(-254.721 -163.252)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M255.023,222.769c5.6-7.035,14.854-13.84,14.854-13.84L286.3,222.21l-14.417,16.914",
    transform: "translate(-255.023 -161.825)",
    fill: "#bf2c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(7.499 121.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(36.749 59.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M283.431,338.251l-8.7,114.521,10.289,6.55s-28.278,1.471-29.2.545,1.16-7.269,1.16-7.269l-4.721-114.62Z",
    transform: "translate(-252.265 -337.979)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M260.216,455.48l-4.21-4.14.6-2.175,6.471,6.326,3.115.011,10.975-5.419,11.916,7.459a1.614,1.614,0,0,1-.862,2.982l-16.015-.057-5.112-3.557-1.451-.005-.012,3.537L255.2,460.4l.018-4.942Z",
    transform: "translate(-252.151 -333.671)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257",
    transform: "translate(0 59.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M261.951,337.653,236.3,452.785l10.29,6.55s-28.278,1.471-29.2.545,1.16-7.269,1.16-7.269l7.5-114.958Z",
    transform: "translate(-216.876 -337.653)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M221.908,455.48l-4.211-4.14.6-2.175,6.47,6.326,3.115.011,10.976-5.419,11.915,7.459a1.614,1.614,0,0,1-.862,2.982l-16.016-.057-5.111-3.557-1.451-.005-.014,3.537-10.43-.037.019-4.942Z",
    transform: "translate(-216.887 -333.332)",
    fill: "#28364c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M234.844,280.479c-14.11,24.833-14.083,71.034-14.083,71.034h65.411s-.9-40.579-8.206-63.443Z",
    transform: "translate(-216.737 -280.479)",
    fill: "#101d54"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    x2: 1.63,
    y2: 68.802,
    transform: "translate(39.965 2.232)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M269.835,285.413s-3.306,8.381-14.474,11.279",
    transform: "translate(-215.396 -280.288)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(21.867 54.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M325.107,257.233c4.3,1.252,17.349,2.834,17.549,3.729s-4.4.4-4.1,1.1,7.323,1.946,7.285,2.893c-.054,1.284-7.178-.374-7.178-.374s7.713,2.2,7.344,3.3c-.261.779-6.224-.633-8.571-.886,2.508.6,6.457,2.049,6.169,2.853s-4.366-.078-7.528-.582c1.944.5,5.433,1.6,5.2,2.352s-10.3-.681-19.729-2.406",
    transform: "translate(-227.2 -214.26)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M251.677,215.863s1.076,2.764,6.949,2.764c4.1,0,5.648-2.15,5.648-2.15s1.51,1.355,17.669,22.564c3.422,4.49,2.683,14.178-3.035,22.555a140.836,140.836,0,0,0-1.328,28.978H230.811s-.815-33.6,2.418-51.928A31.087,31.087,0,0,1,251.677,215.863Z",
    transform: "translate(-230.72 -215.863)",
    fill: "#e03b5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M281.076,229.846C312.239,254.3,333.849,259.6,333.849,259.6l-2.542,11.981s-37.428-4.747-62.012-25.411",
    transform: "translate(-229.225 -215.321)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M263.43,217.233c8,1.345,20.265,13.113,20.265,13.113L270.673,249.46s-5.528-3.828-13.022-10.268",
    transform: "translate(-229.676 -215.81)",
    fill: "#e03b5a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M270.715,247.95c-9.754-5.939-14.14-10.294-14.14-10.294",
    transform: "translate(-229.718 -215.019)",
    fill: "none",
    stroke: "#a31d4a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(0 24.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M267.261,196.145c3.251,5.373,4.6,10.748.04,13.5s-11.88,4.126-16.538-3.525c-3.266-5.365-2.194-11.964,2.361-14.72S264.01,190.77,267.261,196.145Z",
    transform: "translate(-208.149 -186.798)",
    fill: "#f886bc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260",
    transform: "translate(55.293 10.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M262.931,197.265c.151.545.581,1.187,1.12,1.168a.337.337,0,0,0,.315-.24C264.68,197.264,262.617,196.125,262.931,197.265Z",
    transform: "translate(-262.898 -196.787)",
    fill: "#0b0b3a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M260.855,196.868a4.23,4.23,0,0,1,3.087-1.8",
    transform: "translate(-207.685 -186.609)",
    fill: "none",
    stroke: "#0b0b3a",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M267.878,201.821l-3.013,1.506s1.064,2.6,2.692,2.114C268.918,205.035,267.878,201.821,267.878,201.821Z",
    transform: "translate(-207.529 -186.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M263.691,217.752a12.818,12.818,0,0,1-5.847,1.341c-4.706-.117-6.949-2-6.949-2l3.1-13.258,11.409.832Z",
    transform: "translate(-208.071 -186.27)",
    fill: "#f886bc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M265.517,196.159s3.9,2.605,4.033,3.3-1.51,1.7-1.51,1.7",
    transform: "translate(-207.504 -186.567)",
    fill: "#f886bc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M256.78,187.83c-.421.213-1.874-.18-2.4-.18a12.329,12.329,0,0,0-2.211.188c-4.344.793-7.588,4.387-9.633,8.086-1.343,2.429-2.472,5.126-4.916,6.668-5.372,3.386-12.424,2.175-18.444,4.2-6.126,2.062-10.818,8.278-9.174,14.91.537,2.172,1.678,4.148,2.349,6.281,1.432,4.553.762,9.853,3.5,13.764a12.363,12.363,0,0,0,2.7,2.712,18.741,18.741,0,0,0,28.729-7.947c2.431-6.061,1.671-13.281,5.218-18.764,1.656-2.562,4.129-4.515,5.774-7.083,1.5-2.348,2.294-6.763,2.474-9.59.042-.652-1.127-6.081-.777-6.081a13.31,13.31,0,0,0,8.079-3.413A8.247,8.247,0,0,0,256.78,187.83Z",
    transform: "translate(-209.668 -186.925)",
    fill: "#0b0b3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M258.06,201.245a1.894,1.894,0,0,0-2.708.473c-1.388,2.074,1.955,4.7,3.564,4.816s1.567-1.626,1.567-1.626",
    transform: "translate(-207.911 -186.385)",
    fill: "#f886bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(1100.319 5114.178)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(386.205 135.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 101.704,
    height: 135.82,
    fill: "#d9e4f4",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(15.191 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 101.704,
    height: 135.82,
    fill: "#fff",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 74.676,
    height: 17.754,
    rx: 3.595,
    transform: "translate(29.116 10.568)",
    fill: "#d7e3f4",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 42.979,
    height: 49.914,
    rx: 3.595,
    transform: "translate(29.116 74.703)",
    fill: "#d7e3f4",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(29.116 37.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M530.78,214.132h-2.267c-1.825,0-3.3-1.94-3.3-4.335s1.479-4.334,3.3-4.334h2.267Z",
    transform: "translate(-525.209 -205.464)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M534,209.8c0,2.394-1.479,4.335-3.3,4.335s-3.305-1.94-3.305-4.335,1.479-4.334,3.305-4.334S534,207.4,534,209.8Z",
    transform: "translate(-525.124 -205.464)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(51.049 37.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M551.895,214.132h-2.267c-1.825,0-3.3-1.94-3.3-4.335s1.479-4.334,3.3-4.334h2.267Z",
    transform: "translate(-546.324 -205.464)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M555.115,209.8c0,2.394-1.479,4.335-3.3,4.335s-3.305-1.94-3.305-4.335,1.48-4.334,3.305-4.334S555.115,207.4,555.115,209.8Z",
    transform: "translate(-546.24 -205.464)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(72.983 37.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M573.01,214.132h-2.266c-1.825,0-3.305-1.94-3.305-4.335s1.48-4.334,3.305-4.334h2.266Z",
    transform: "translate(-567.439 -205.464)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M576.231,209.8c0,2.394-1.48,4.335-3.305,4.335s-3.3-1.94-3.3-4.335,1.479-4.334,3.3-4.334S576.231,207.4,576.231,209.8Z",
    transform: "translate(-567.354 -205.464)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(94.917 37.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M594.126,214.132h-2.267c-1.825,0-3.3-1.94-3.3-4.335s1.479-4.334,3.3-4.334h2.267Z",
    transform: "translate(-588.555 -205.464)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M597.346,209.8c0,2.394-1.479,4.335-3.3,4.335s-3.305-1.94-3.305-4.335,1.48-4.334,3.305-4.334S597.346,207.4,597.346,209.8Z",
    transform: "translate(-588.471 -205.464)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(29.116 58.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M530.78,234.342h-2.267c-1.825,0-3.3-1.941-3.3-4.335s1.479-4.334,3.3-4.334h2.267Z",
    transform: "translate(-525.209 -225.674)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M534,230.008c0,2.393-1.479,4.335-3.3,4.335s-3.305-1.941-3.305-4.335,1.479-4.334,3.305-4.334S534,227.614,534,230.008Z",
    transform: "translate(-525.124 -225.674)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(51.049 58.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M551.895,234.342h-2.267c-1.825,0-3.3-1.941-3.3-4.335s1.479-4.334,3.3-4.334h2.267Z",
    transform: "translate(-546.324 -225.674)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M555.115,230.008c0,2.393-1.479,4.335-3.3,4.335s-3.305-1.941-3.305-4.335,1.48-4.334,3.305-4.334S555.115,227.614,555.115,230.008Z",
    transform: "translate(-546.24 -225.674)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(72.983 58.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M573.01,234.342h-2.266c-1.825,0-3.305-1.941-3.305-4.335s1.48-4.334,3.305-4.334h2.266Z",
    transform: "translate(-567.439 -225.674)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M576.231,230.008c0,2.393-1.48,4.335-3.305,4.335s-3.3-1.941-3.3-4.335,1.479-4.334,3.3-4.334S576.231,227.614,576.231,230.008Z",
    transform: "translate(-567.354 -225.674)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(94.917 58.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M594.126,234.342h-2.267c-1.825,0-3.3-1.941-3.3-4.335s1.479-4.334,3.3-4.334h2.267Z",
    transform: "translate(-588.555 -225.674)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M597.346,230.008c0,2.393-1.479,4.335-3.3,4.335s-3.305-1.941-3.305-4.335,1.48-4.334,3.305-4.334S597.346,227.614,597.346,230.008Z",
    transform: "translate(-588.471 -225.674)",
    fill: "#d7e3f4"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(0 305.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M125.381,465.034h172.6V332.777H168.811l-43.43,50.787Z",
    transform: "translate(-125.381 -332.777)",
    fill: "#fff",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M244.373,465.034h63.6V332.777H286.927l-42.554,50.788Z",
    transform: "translate(-120.77 -332.777)",
    fill: "#d9e4f4",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 123.603,
    height: 81.47,
    transform: "translate(123.603 132.257) rotate(180)",
    fill: "#d9e4f4",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(131.723 5.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M255.109,347.406c1.184,1.083,3.6.354,5.408-1.628s2.3-4.469,1.121-5.551l-2.451-2.245-6.529,7.18Z",
    transform: "translate(-252.172 -337.622)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M252.831,345.317c1.183,1.082,3.6.354,5.407-1.629s2.3-4.468,1.122-5.551-3.6-.353-5.407,1.629S251.648,344.233,252.831,345.317Z",
    transform: "translate(-252.19 -337.636)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275",
    transform: "translate(112.484 5.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M236.587,347.406c1.183,1.083,3.6.354,5.407-1.628s2.3-4.469,1.122-5.551l-2.451-2.245-6.529,7.18Z",
    transform: "translate(-233.65 -337.622)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M234.309,345.317c1.183,1.082,3.6.354,5.407-1.629s2.3-4.468,1.122-5.551-3.6-.353-5.407,1.629S233.126,344.233,234.309,345.317Z",
    transform: "translate(-233.668 -337.636)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(72.881 5.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M198.462,347.406c1.183,1.083,3.6.354,5.408-1.628s2.3-4.469,1.121-5.551l-2.451-2.245-6.529,7.18Z",
    transform: "translate(-195.525 -337.622)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M196.184,345.317c1.183,1.082,3.6.354,5.407-1.629s2.3-4.468,1.122-5.551-3.6-.353-5.407,1.629S195,344.233,196.184,345.317Z",
    transform: "translate(-195.543 -337.636)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(52.48 5.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M178.822,347.406c1.183,1.083,3.6.354,5.407-1.628s2.3-4.469,1.122-5.551l-2.452-2.245-6.527,7.18Z",
    transform: "translate(-175.885 -337.622)",
    fill: "#b2cded"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M176.544,345.317c1.182,1.082,3.6.354,5.406-1.629s2.306-4.468,1.122-5.551-3.6-.353-5.407,1.629S175.361,344.233,176.544,345.317Z",
    transform: "translate(-175.903 -337.636)",
    fill: "#d7e3f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M246.888,373.09l6.859-8.886H149.307l-7.847,8.886Z",
    transform: "translate(-124.757 -331.559)",
    fill: "#d7e3f4",
    opacity: 0.45
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M357.161,313.278V423.733a9.674,9.674,0,0,1-9.674,9.674H286.041a9.674,9.674,0,0,1-9.673-9.674v-3.167",
    transform: "translate(-119.53 -28.122)",
    fill: "none",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M373.18,318.158V444.351a9.865,9.865,0,0,1-9.865,9.865H265.623a9.674,9.674,0,0,1-9.674-9.674V420.377",
    transform: "translate(-120.321 -27.933)",
    fill: "none",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M395.419,318.432v73.21a9.673,9.673,0,0,0,9.673,9.673H481.4a9.674,9.674,0,0,0,9.674-9.673V266.226a9.673,9.673,0,0,1,9.673-9.674h31.464",
    transform: "translate(-114.917 -30.32)",
    fill: "none",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M383.61,319.652v102.61a9.674,9.674,0,0,0,9.673,9.674h140.1a9.675,9.675,0,0,0,9.674-9.674V279.609",
    transform: "translate(-115.375 -29.427)",
    fill: "none",
    stroke: "#648acc",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296",
    transform: "translate(164.236)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(4.035 38.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M287.374,166.979a91.021,91.021,0,1,1,164.59,53.6h0c-12.993,19.578-46.751,41.683-46.751,54.926V290.63a5.468,5.468,0,0,1-5.468,5.468h-42.7a5.468,5.468,0,0,1-5.468-5.468V275.5c0-13.243-33.758-35.348-46.751-54.926h0A90.6,90.6,0,0,1,287.374,166.979Z",
    transform: "translate(-287.374 -75.959)",
    fill: "#fdd305"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(40.291 130.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M387.378,291.145c-.106-2.281-1.736-38.819,1.19-70.841a102.464,102.464,0,0,1-23.051,0c2.925,32.021,1.3,68.559,1.188,70.841l-1.6-.075c.026-.563,1.714-38.356-1.277-70.984-27-3.754-39.08-19.046-41.25-33.481-1.267-8.436,1.613-16.832,6.851-19.964a13.756,13.756,0,0,1,11.1-1.113c6.429,1.845,12.539,7.384,16.345,14.819,4.394,8.586,6.992,22.842,8.49,38.318a100.278,100.278,0,0,0,23.358,0c1.5-15.476,4.1-29.732,8.491-38.318,3.806-7.434,9.916-12.974,16.345-14.819a13.76,13.76,0,0,1,11.1,1.113c5.237,3.132,8.119,11.528,6.851,19.964-2.17,14.434-14.254,29.727-41.251,33.481-2.99,32.628-1.3,70.421-1.276,70.984Zm30.681-124.67a14.709,14.709,0,0,0-4.059.6c-6.01,1.724-11.75,6.961-15.358,14.006-4.226,8.258-6.752,22.165-8.227,37.36,25.861-3.728,37.436-18.308,39.506-32.073,1.156-7.693-1.459-15.579-6.086-18.345A11.113,11.113,0,0,0,418.06,166.474Zm-82.034,0a11.115,11.115,0,0,0-5.775,1.547c-4.626,2.766-7.242,10.652-6.086,18.345,2.069,13.765,13.644,28.345,39.5,32.073-1.475-15.195-4-29.1-8.226-37.36-3.608-7.046-9.348-12.282-15.358-14.006A14.709,14.709,0,0,0,336.026,166.474Z",
    transform: "translate(-322.278 -164.864)",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(108.51 50.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M450.365,171.745a5.222,5.222,0,0,1-5.222-5.223A70.552,70.552,0,0,0,391.9,98.035a5.222,5.222,0,1,1,2.563-10.126,80.987,80.987,0,0,1,61.129,78.613A5.222,5.222,0,0,1,450.365,171.745Z",
    transform: "translate(-387.952 -87.747)",
    fill: "#fe9"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    "data-name": "Group 283",
    transform: "translate(93.303 48.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M373.312,90.6a5.222,5.222,0,1,0,5.222-5.222A5.222,5.222,0,0,0,373.312,90.6Z",
    transform: "translate(-373.312 -85.382)",
    fill: "#fe9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(4.21 135.043)",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_284",
    "data-name": "Group 284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M469.235,168.765c-5.023,37.322-35.156,75.962-90.846,75.962s-84.7-40.447-90.846-75.962a90.549,90.549,0,0,0,17.277,48.213h0c12.993,19.578,46.751,41.683,46.751,54.926v15.129a5.468,5.468,0,0,0,5.468,5.468h42.7a5.468,5.468,0,0,0,5.468-5.468V271.9c0-13.243,33.758-35.348,46.751-54.926h0A90.541,90.541,0,0,0,469.235,168.765Z",
    transform: "translate(-287.543 -168.765)",
    fill: "#ffc043"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_287",
    "data-name": "Group 287",
    transform: "translate(66.087 244.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M405.048,274.276H347.112v27.613a23.757,23.757,0,0,0,3.7,12.731h0a24.9,24.9,0,0,0,21.022,11.556h8.493a24.9,24.9,0,0,0,21.022-11.556h0a23.756,23.756,0,0,0,3.7-12.731Z",
    transform: "translate(-347.112 -274.276)",
    fill: "#28364c"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(62.472 250.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M347.243,292.7a3.705,3.705,0,0,0,.5-.018l57.936-6.006a3.472,3.472,0,0,0,3.084-3.97,3.767,3.767,0,0,0-4.077-3.226l-57.937,6.005a3.473,3.473,0,0,0-3.084,3.97A3.779,3.779,0,0,0,347.243,292.7Z",
    transform: "translate(-343.632 -279.456)",
    fill: "#475577"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_291",
    "data-name": "Group 291",
    transform: "translate(62.472 262.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_290",
    "data-name": "Group 290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M347.243,304.862a3.71,3.71,0,0,0,.5-.018l57.936-6.006a3.471,3.471,0,0,0,3.084-3.97,3.77,3.77,0,0,0-4.077-3.226l-57.937,6.006a3.471,3.471,0,0,0-3.084,3.969A3.778,3.778,0,0,0,347.243,304.862Z",
    transform: "translate(-343.632 -291.623)",
    fill: "#475577"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(64.786 275.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M349.471,316.892a3.533,3.533,0,0,0,.5-.018l54.915-5.693a3.472,3.472,0,0,0,3.085-3.969,3.769,3.769,0,0,0-4.077-3.227l-54.917,5.693a3.471,3.471,0,0,0-3.084,3.97A3.777,3.777,0,0,0,349.471,316.892Z",
    transform: "translate(-345.86 -303.965)",
    fill: "#475577"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y2: 28.603,
    transform: "translate(95.056)",
    fill: "#ffcd5c",
    stroke: "#ffc043",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(0 11.392)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 11.552,
    y2: 26.166,
    transform: "translate(135.085)",
    fill: "#ffcd5c",
    stroke: "#ffc043",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x1: 21.136,
    y2: 19.272,
    transform: "translate(168.977 31.646)",
    fill: "#ffcd5c",
    stroke: "#ffc043",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 11.552,
    y2: 26.166,
    transform: "translate(43.475)",
    fill: "#ffcd5c",
    stroke: "#ffc043",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 21.136,
    y2: 19.272,
    transform: "translate(0 31.646)",
    fill: "#ffcd5c",
    stroke: "#ffc043",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 1.97,
    cy: 1.97,
    r: 1.97,
    transform: "translate(133.658 390.622)",
    fill: "#648acc"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.97,
    cy: 1.97,
    r: 1.97,
    transform: "translate(154.867 390.622)",
    fill: "#648acc"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 1.97,
    cy: 1.97,
    r: 1.97,
    transform: "translate(425.708 248.212)",
    fill: "#648acc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 1.97,
    cy: 1.97,
    r: 1.97,
    transform: "translate(436.81 248.212)",
    fill: "#648acc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M560.525,279.683a1.971,1.971,0,1,1-1.971-1.971A1.971,1.971,0,0,1,560.525,279.683Z",
    transform: "translate(-108.672 -29.5)",
    fill: "#648acc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 1.97,
    cy: 1.97,
    r: 1.97,
    transform: "translate(415.321 224.262)",
    fill: "#648acc"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(1403.732 5402.578)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_35",
    "data-name": "Ellipse 35",
    cx: 40.651,
    cy: 40.651,
    r: 40.651,
    transform: "translate(0 31.362) rotate(-22.69)",
    fill: "#f46072"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 29.409,
    cy: 29.409,
    r: 29.409,
    transform: "translate(17.991 31.024) rotate(-12.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M449.23,368.357a20.2,20.2,0,1,0,20.2-20.2A20.2,20.2,0,0,0,449.23,368.357Z",
    transform: "translate(-416.245 -315.171)",
    fill: "#f46072"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M458.49,368a10.582,10.582,0,1,0,10.582-10.582A10.582,10.582,0,0,0,458.49,368Z",
    transform: "translate(-415.886 -314.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(51.548 0.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298",
    transform: "translate(0 47.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M467.1,369.428h6.645l-6.645-6.645Z",
    transform: "translate(-467.1 -362.783)",
    fill: "#0c3656"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299",
    transform: "translate(43.087 3.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M508.58,327.984h7.6v-1.917H510.5v-5.686H508.58Z",
    transform: "translate(-508.58 -320.381)",
    fill: "#0c3656"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300",
    transform: "translate(46.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M511.93,324.634h7.6v-1.917h-5.686v-5.686H511.93Z",
    transform: "translate(-511.93 -317.031)",
    fill: "#0c3656"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(1.187 5.652)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 65.019,
    height: 1.917,
    transform: "translate(0 45.975) rotate(-44.999)",
    fill: "#0c3656"
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(1032.289 5354.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(92.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M168.422,298.133l-5.014,9.521a20.312,20.312,0,0,1-8.14-2.33c-4.686-2.313-6.051-5.5-6.051-5.5l8.477-11.214",
    transform: "translate(-149.218 -269.118)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M178.818,280.658c4.663,2.747-3.039,20.149-7.247,21.25s-12.563-7.121-15.054-14.086,5.522-10.776,10.234-12.192S178.818,280.658,178.818,280.658Z",
    transform: "translate(-148.953 -269.628)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M174.876,288.713q-.2.436-.407.87",
    transform: "translate(-148.24 -269.114)",
    fill: "none",
    stroke: "#00276f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M177.264,286.991s-1.023-1.534-3.716-1",
    transform: "translate(-148.275 -269.223)",
    fill: "none",
    stroke: "#00276f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M170.694,295.1l2.967,2.119s-1.159,2.243-2.219,1.37S170.694,295.1,170.694,295.1Z",
    transform: "translate(-148.388 -268.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M183.114,284.687a45.282,45.282,0,0,1-6.05-2.777c-2.143.444-4.37,2.454-4.427,4.73-.012.512-.064,1.209-.572,1.28-.35.049-.639-.293-.738-.633a8.564,8.564,0,0,0-.224-1.035,1.489,1.489,0,0,0-1.829-.691,2.585,2.585,0,0,0-1.444,1.508c-.708,1.692-1.34,3.74.275,5.158a2.939,2.939,0,0,1,.707.7c.351.636-.063,1.41-.478,2a8.017,8.017,0,0,1-7.006,3.922c-2.664,0-7.09-3.514-7.382-5.27-.026-.157-2.576-10.913,2.155-17.755,2.539-3.67,7.007-6.343,11.667-5.953a13.537,13.537,0,0,1,6.8,3.034C182.341,274.346,184.007,282.355,183.114,284.687Z",
    transform: "translate(-149.062 -269.845)",
    fill: "#212237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M177.811,290.248s.688,5.217-.341,5.787-3.2-.915-3.2-.915",
    transform: "translate(-148.247 -269.054)",
    fill: "#f886bc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(0 90.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307",
    transform: "translate(118.929 69.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M179.889,426.292l-3.8,24.56-.2,7.4,29-.149a1.282,1.282,0,0,0,1.276-1.288h0a1.283,1.283,0,0,0-.828-1.192l-12.505-5.751,4.947-25.512",
    transform: "translate(-174.323 -424.357)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M207.487,456.836a3.942,3.942,0,0,0-1.389-2.208l-13.26-5.711c-7.31,2.963-16.771.7-16.771.7l-1.687,9.983a.6.6,0,0,0,.6.6l32.282-.165C207.915,460.025,207.5,456.866,207.487,456.836Z",
    transform: "translate(-174.381 -423.405)",
    fill: "#4868ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M194.983,449.467a15.615,15.615,0,0,0-1.87,3.139",
    transform: "translate(-173.655 -423.384)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M196.577,450.428a13.765,13.765,0,0,0-1.537,2.67",
    transform: "translate(-173.58 -423.347)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M197.932,451.13a19.57,19.57,0,0,0-1.441,2.449",
    transform: "translate(-173.524 -423.32)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y1: 0.169,
    x2: 33.072,
    transform: "translate(0.17 34.464)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M175.429,453s7.77.158,8.438,4.839",
    transform: "translate(-174.34 -423.247)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M202.395,453.288a25.177,25.177,0,0,0-2.565,4.448",
    transform: "translate(-173.395 -423.236)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(0 73.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M94.267,432.532l-24.195-2.883-7.395-.2.148,29a1.282,1.282,0,0,0,1.289,1.275h0a1.28,1.28,0,0,0,1.191-.828l5.751-12.505,25.073,2.823",
    transform: "translate(-59.78 -427.886)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M63.246,461.05a3.938,3.938,0,0,0,2.207-1.389l5.711-13.26c-2.963-7.309-.7-16.77-.7-16.77l-9.983-1.688a.6.6,0,0,0-.6.6l.165,32.283C60.056,461.478,63.216,461.059,63.246,461.05Z",
    transform: "translate(-59.888 -427.944)",
    fill: "#4868ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M70.311,448.546a15.635,15.635,0,0,0-3.139-1.87",
    transform: "translate(-59.606 -427.218)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M69.333,450.14a13.7,13.7,0,0,0-2.67-1.536",
    transform: "translate(-59.625 -427.143)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M68.623,451.5a19.739,19.739,0,0,0-2.449-1.442",
    transform: "translate(-59.644 -427.087)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 0.169,
    y2: 33.072,
    transform: "translate(2.155 0.171)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M66.843,428.993s-.158,7.769-4.838,8.437",
    transform: "translate(-59.806 -427.903)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M66.539,455.958a25.136,25.136,0,0,0-4.448-2.565",
    transform: "translate(-59.803 -426.958)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M108.236,367.909c-5.2,13.9,3.287,34.08,3.287,34.08l4.473,32.5-42.425-1.868.42,28.216s45.505,3.237,56.513,3.237,15.261-2.463,18.492-8.911c4.813-9.609-2.1-62.729-2.1-63.61l-7.553-34.122",
    transform: "translate(-59.358 -357.435)",
    fill: "#22252d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 0.319,
    y2: 28.339,
    transform: "translate(19.305 75.415)",
    fill: "none",
    stroke: "#474b51",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M121.124,374.932s-4.816,24.611,19.632,29.9c10.926,2.363,38.706,3.139,38.706,3.139l-4.744,38.022h27.741s5.747-28.648,7.478-47.809c1.151-12.749-4.332-18.449-14.64-19.727-8.724-1.082-34.963-2.789-34.963-2.789l-4.411-5.538",
    transform: "translate(-57.53 -356.943)",
    fill: "#22252d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M146.236,405.243s-20.574.062-25.5-22.995",
    transform: "translate(-57.53 -356.474)",
    fill: "none",
    stroke: "#474b51",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M131.192,380.155a56.031,56.031,0,0,0,12.818.591",
    transform: "translate(-57.125 -356.555)",
    fill: "none",
    stroke: "#474b51",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M105.325,377.016a40.949,40.949,0,0,0,9.05,1.537",
    transform: "translate(-58.127 -356.676)",
    fill: "none",
    stroke: "#474b51",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 26.934,
    transform: "translate(119.022 84.1)",
    fill: "none",
    stroke: "#474b51",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314",
    transform: "translate(46.844 30.05)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    transform: "translate(124.6 33.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(2.967 6.515)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 2.208,
    height: 24.135,
    fill: "#648acc"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 4.071,
    cy: 4.071,
    r: 4.071,
    fill: "#648acc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M209.2,341.739l8.189.6s6.295-2.124,8.8-2.177a3.276,3.276,0,0,1,2.333.778v2.474c0,1.648,2.207,2.375,2.207,1.256v-1.362c.026.091,4.535,2.234,1.893,4.274,1.24.257,1.9,2-.454,3.194a1.715,1.715,0,0,1-.115,3.057c.766,1.164-.792,2.447-2.029,2.715-2.341.506-21.077.112-21.077.112",
    transform: "translate(-100.957 -297.17)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M165.436,306.367c13.454,18.609,6.227,24.64-3.441,72.113a286.7,286.7,0,0,1-57.01-5.585,363.713,363.713,0,0,1,21.945-52.639c6.8-13.22,18.1-19.8,24.492-21.482",
    transform: "translate(-104.985 -298.774)",
    fill: "#4868ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M143.532,327.008s20.788,32.559,30.668,34c15.686,2.293,41.626,1.65,41.626,1.65l1.548-22.905s-33.344-1.686-34.72-2.468c-4.467-2.54-18.711-31.2-18.711-31.2",
    transform: "translate(-103.491 -298.491)",
    fill: "#4868ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M165.6,354.206a91.972,91.972,0,0,1-20.315-25.843",
    transform: "translate(-103.423 -297.627)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x1: 1.965,
    y2: 23.241,
    transform: "translate(107.109 41.01)",
    fill: "none",
    stroke: "#273b7a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(1519.38 5268.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316",
    transform: "translate(104.03 60.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M634.813,303.651c-.5,4.449-4.077,17.1-3.328,17.629s2.064-3.9,2.6-3.355-1.029,7.508-.14,7.837c1.2.446,2.423-6.766,2.423-6.766s-.941,7.966.216,8.05c.82.059,1.818-5.986,2.489-8.25-.416,2.545-.6,6.748.252,6.792s1.612-4.058,2.367-7.169c-.29,1.986-.622,5.628.163,5.706s3.344-9.767,5.39-19.131",
    transform: "translate(-628.865 -242.616)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M649.39,244.893s7.2,12.789,8.239,20.639c2.562,19.337-13.483,52.093-13.483,52.093s-11.659-3.181-11.659-4.643,8.125-35.881,8.125-35.881l-11.654-26.9",
    transform: "translate(-628.959 -244.893)",
    fill: "#f886bc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(70.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M615.475,204.463l1.563,14.42s-8.645,7.33-16.3-.882l.935-9.492Z",
    transform: "translate(-596.958 -186.259)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M603.553,190.555s-9.359,12.889-5.536,17.72c2.821,3.565,10.222,3.97,12.51,2.569.491-2.641,6.558-11.365,5.584-13.305C612.393,190.12,603.553,190.555,603.553,190.555Z",
    transform: "translate(-597.099 -186.798)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M618.041,192.924c-.3-4.873-5.107-6.3-14.33-5.749-1.235.074-3.432-.765-4,.332-.75,1.443-.883,4.361.565,5.675a5.313,5.313,0,0,0,2.886,1.363c1.671.391,3.374,1.982,2.485,3.732-.233.459-.784,1.236-.435,1.614a4.98,4.98,0,0,0,1,.525c.664.355.621,1.364.208,1.993s-.229,1.326-.644,1.954c-.987,1.485.183,4.224,1.717,5.132,1.357.8,5.808,2.146,9.065.456,2.826-1.465,4.524-5.451,4.547-12.621C621.112,194.582,619.068,192.737,618.041,192.924Z",
    transform: "translate(-597.019 -186.938)",
    fill: "#212237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M604.349,199.84c1.521-1.927,2.751-1.62,3.423-.562.9,1.411-.9,4.343-1.737,4.844-1.7,1.015-3.069.908-3.2-.468",
    transform: "translate(-596.876 -186.492)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318",
    transform: "translate(3.05 10.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M600.708,196.953c-.434.363-.841,1.019-.6,1.5a.337.337,0,0,0,.349.187C601.431,198.546,601.617,196.2,600.708,196.953Z",
    transform: "translate(-600.035 -196.803)",
    fill: "#28364c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M600.8,195.227a3.613,3.613,0,0,1,1.956,1.537",
    transform: "translate(-596.955 -186.616)",
    fill: "none",
    stroke: "#28364c",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M600.892,203.608l-2.137-1.144s-1.4,2.626-.409,3.18C599.446,206.256,600.892,203.608,600.892,203.608Z",
    transform: "translate(-597.064 -186.336)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(42.521 80.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320",
    transform: "translate(0 172.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 33.766,
    height: 1.512,
    transform: "matrix(-1, 0.001, -0.001, -1, 33.767, 30.44)",
    fill: "#103bb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M598.706,446.619l2.922.689s1.118,3.816,1.547,6.473a31.053,31.053,0,0,1,.335,5.3l-33.766.025s.883-2.926,8.939-7.645a17.581,17.581,0,0,0,4.791-3.988Z",
    transform: "translate(-569.745 -430.157)",
    fill: "#22252d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M601.713,435.084l-.555,12.838s-1.418,1.714-7.152,1.719a43.862,43.862,0,0,1-11-1.55l-1.132-17.32",
    transform: "translate(-569.275 -430.771)",
    fill: "#f2b18f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321",
    transform: "translate(48.094 172.441)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 33.766,
    height: 1.512,
    transform: "translate(33.767 30.44) rotate(179.956)",
    fill: "#103bb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M645.005,446.619l2.922.689s1.118,3.816,1.548,6.473a31.057,31.057,0,0,1,.336,5.3l-33.766.025s.882-2.926,8.938-7.645a17.6,17.6,0,0,0,4.792-3.988Z",
    transform: "translate(-616.044 -430.157)",
    fill: "#22252d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M646.374,434.56l1.138,13.361s-1.417,1.714-7.151,1.719a43.851,43.851,0,0,1-11-1.55l-2.6-17.32",
    transform: "translate(-615.629 -430.771)",
    fill: "#f2b18f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M641.926,308.142s5.266,10.967,1.034,31.952c2.154,46.853,7.757,109.838,7.757,109.838l-32.171-.113s-6.56-67.706-10.459-101.446c-4.344-37.584-7.06-83.611-7.06-83.611",
    transform: "translate(-568.533 -264.762)",
    fill: "#0070e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M623.282,446.7s-6.56-67.706-10.459-101.446",
    transform: "translate(-568.076 -261.643)",
    fill: "none",
    stroke: "#0b2e6b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M581.443,309.622s-3.417,49.392-3.417,73.1-1.523,66.594-1.523,66.594h32.518L621.12,337.2c9.909-11.869,9.186-37.623,6.8-47.651l-32.244-8.8Z",
    transform: "translate(-569.483 -264.143)",
    fill: "#0070e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M613.06,397.438l6.644-61.563a34.476,34.476,0,0,0,8.311-20.963",
    transform: "translate(-568.066 -262.819)",
    fill: "none",
    stroke: "#0b2e6b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x1: 7.696,
    y2: 144.652,
    transform: "translate(11.053 40.519)",
    fill: "none",
    stroke: "#0b2e6b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x2: 15.795,
    y2: 0.316,
    transform: "translate(40.106 53.553)",
    fill: "none",
    stroke: "#0b2e6b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y1: 0.125,
    x2: 6.005,
    transform: "translate(67.158 52.93)",
    fill: "none",
    stroke: "#0b2e6b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(0 25.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M555.878,237.063c-4.408-4.989-16.24-23.955-17.569-23.655s2.252,6.168,1.114,6.21-7.26-8.615-8.51-7.962c-1.692.886,5.054,9.416,5.054,9.416s-2.641-3.624-3.887-2.431c-.883.846-.417,2.62,1.412,5.614-1.227-1.533-2.384-1.8-3.282-.908s-.008,2.524,1.089,4.176c-.865-1.082-2.129-1.627-2.453-.5-.425,1.476,3.155,9.132,11.622,21.616",
    transform: "translate(-528.81 -211.62)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M617.759,216.945s18.632.781,24.219,21.987c2.52,9.561,4.141,75.123,4.141,75.123l-68.083-.456s.907-59.271,2.43-72.1c2.783-23.453,21.25-24.915,21.25-24.915s.84,2.074,8.058,2.074S617.759,216.945,617.759,216.945Z",
    transform: "translate(-526.902 -211.428)",
    fill: "#d8cac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M616.277,216.931c22.114,0,35.731,30.377,35.731,30.377L638.1,254.292",
    transform: "translate(-525.42 -211.414)",
    fill: "#d8cac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M590.277,259.661s-11.8,16.981-21.329,17.9c-12.807,1.239-35.591-41.4-35.591-41.4l14.372-9.707,19.684,24.758,6.714-10.034",
    transform: "translate(-528.633 -211.045)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M602.063,216.579c-19.04,1.047-32.976,29.411-32.976,29.411l22.294,16,12.654-16.506",
    transform: "translate(-527.249 -211.428)",
    fill: "#d8cac0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    y1: 14.027,
    x2: 10.784,
    transform: "translate(63.347 35.974)",
    fill: "none",
    stroke: "#846a6a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M641.554,251.452a79.871,79.871,0,0,0-4.266-16.538",
    transform: "translate(-524.606 -210.718)",
    fill: "none",
    stroke: "#846a6a",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M600.018,197.991s-3.066,1.473-2.914,2.035a11.137,11.137,0,0,0,1.074,1.922",
    transform: "translate(-526.164 -186.509)",
    fill: "#f886bc"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x2: 33.085,
    transform: "translate(49.542 258.961)",
    fill: "none",
    stroke: "#0b2e6b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x2: 32.179,
    transform: "translate(91.857 259.241)",
    fill: "none",
    stroke: "#0b2e6b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec);
export default __webpack_public_path__ + "static/media/Sec.81f06782893d9c90d2c6ebd936b06dd6.svg";
export { ForwardRef as ReactComponent };